// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ICardReplaceDto
 */
export interface ICardReplaceDto {
    /**
     * 
     * @type {string}
     * @memberof ICardReplaceDto
     */
    reason: ICardReplaceDtoReasonEnum;
    /**
     * 
     * @type {string}
     * @memberof ICardReplaceDto
     */
    replacement_initiation_type?: ICardReplaceDtoReplacementInitiationTypeEnum;
}

/**
* @export
* @enum {string}
*/
export enum ICardReplaceDtoReasonEnum {
    LOST = 'LOST',
    STOLEN = 'STOLEN',
    NOT_SENT = 'NOT_SENT',
    DAMAGED = 'DAMAGED',
    DEMOGRAPHIC_CHANGE = 'DEMOGRAPHIC_CHANGE'
}
/**
* @export
* @enum {string}
*/
export enum ICardReplaceDtoReplacementInitiationTypeEnum {
    BANNER = 'BANNER',
    CARDS_PAGE = 'CARDS_PAGE',
    ADMIN_PORTAL = 'ADMIN_PORTAL'
}


/**
 * Check if a given object implements the ICardReplaceDto interface.
 */
export function instanceOfICardReplaceDto(value: object): value is ICardReplaceDto {
    if (!('reason' in value) || value['reason'] === undefined) return false;
    return true;
}

export function ICardReplaceDtoFromJSON(json: any): ICardReplaceDto {
    return ICardReplaceDtoFromJSONTyped(json, false);
}

export function ICardReplaceDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): ICardReplaceDto {
    if (json == null) {
        return json;
    }
    return {
        
        'reason': json['reason'],
        'replacement_initiation_type': json['replacement_initiation_type'] == null ? undefined : json['replacement_initiation_type'],
    };
}

export function ICardReplaceDtoToJSON(json: any): ICardReplaceDto {
    return ICardReplaceDtoToJSONTyped(json, false);
}

export function ICardReplaceDtoToJSONTyped(value?: ICardReplaceDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'reason': value['reason'],
        'replacement_initiation_type': value['replacement_initiation_type'],
    };
}

